import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorCreateAndUpdate } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.ttsEvent;

/*  
   TTS Event
*/

export const createTTSEvent = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getTTSEvent = (params = {}, callback) => {
  params = {
    page: 1,
    limit: 1000,
    ...params,
  };
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getTTSEventDetail = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateTTSEvent = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

//? remove iot partner
export const removeTTSEvent = (id) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => Toast("success", "Thành công"))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
